export const SVP_ASSET_ADDITIONAL = [
  'settings',
  'chapters',
  'cuePoints',
  'externalId',
  'externalCategoryId',
  'nextAsset',
  'sourceFiles',
  'subtitles',
  'metadata',
  'access',
  'tags',
  'stories',
].join('|');
